import { Box, Link } from "@mui/material";

export function PayPalBadge() {
  const openPayPalPopup = (e: React.MouseEvent) => {
    e.preventDefault();
    window.open(
      "https://www.paypal.com/webapps/mpp/paypal-popup",
      "WIPaypal",
      "toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=yes, width=1060, height=700"
    );
  };

  return (
    <Box sx={{ mt: 2, textAlign: "center" }}>
      <Link
        href="https://www.paypal.com/webapps/mpp/paypal-popup"
        onClick={openPayPalPopup}
        underline="none"
      >
        <img
          src="https://www.paypalobjects.com/webstatic/mktg/logo/bdg_secured_by_pp_2line.png"
          alt="Secured by PayPal"
          style={{ height: "40px" }}
        />
      </Link>
      <Box mt={1}>
        <Link
          href="https://www.paypal.com/gd/webapps/mpp/what-is-paypal"
          target="_blank"
          rel="noopener noreferrer"
          fontWeight="bold"
          color="primary"
        >
          How PayPal Works
        </Link>
      </Box>
    </Box>
  );
}
